import { ICommonTranslationFooter } from '../../types/common/footer';

const initTranslationFooter: ICommonTranslationFooter = {
    showMenu: '',
};

export default initTranslationFooter;
